import { SITE } from '@/app/constants';
import type { SupportedLanguage, UserInfo } from '@/app/types';
import { periodOfValidity } from '@/app/utils';

// 统一的活动配置类型
export interface HeaderActivityConfig {
  key: string;
  imageUrl: string | Partial<Record<SupportedLanguage, string>>;
  // 显示条件
  conditions: {
    time: {
      start: string;
      end: string;
    };
    site?: 'china' | 'global';
    region?: string[];
    locale?: SupportedLanguage[];
  };
  // 点击行为
  getRedirectUrl?: (userInfo: UserInfo | null) => {
    url: string;
    target?: string;
  };
}

// 统一的活动配置数组
export const HEADER_ACTIVITIES: HeaderActivityConfig[] = [
  // 日语区12月主题活动The ReMake - 只在海外日语页面显示
  {
    key: 'theReMake',
    imageUrl: 'https://image01.cf.vidu.studio/vidu/media-asset/20251203-192046-8ec1245d.webp',
    conditions: {
      time: {
        start: '2025-12-08T00:00:00Z',
        end: '2026-01-04T23:59:59Z',
      },
      site: 'global',
      locale: ['ja'],
      region: ['JP'],
    },
    getRedirectUrl: () => {
      return {
        url: '/activity?id=3059284464877130',
      };
    },
  },
];

// 检查活动是否应该显示
export const shouldShowActivity = (
  activity: HeaderActivityConfig,
  region: string | null,
  locale: SupportedLanguage,
): boolean => {
  const { site, region: allowedRegions, locale: allowedLocales, time } = activity.conditions;

  // 检查站点条件
  if (site && SITE !== site) {
    return false;
  }

  // 检查语言和地区条件, 如果语言和地区都不符合条件，则不显示
  if (
    allowedLocales &&
    !allowedLocales.includes(locale) &&
    allowedRegions &&
    region &&
    !allowedRegions.includes(region)
  ) {
    return false;
  }

  // 检查时间限制
  const startTime = time.start;
  const endTime = time.end;
  if (!periodOfValidity([startTime, endTime])) {
    return false;
  }

  return true;
};

// 获取活动图片URL
export const getActivityImageUrl = (activity: HeaderActivityConfig, locale: SupportedLanguage): string | undefined => {
  if (typeof activity.imageUrl === 'string') {
    return activity.imageUrl;
  }

  // 多语言图片
  const imageUrl = activity.imageUrl[locale] || activity.imageUrl.en;
  return imageUrl || undefined;
};
